var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.auflageLeft > 0
      ? _c(
          "div",
          {
            class: _vm.addClassesForTextColor
              ? "text-warning"
              : "" + "font-weight-light",
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("translate")(
                    "versandaufteilungNochZuVerteilen",
                    _vm.auflageLeft
                  )
                ) +
                "\n    "
            ),
          ]
        )
      : _vm.auflageLeft < 0
      ? _c("div", { staticClass: "text-error font-weight-light" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm._f("translate")(
                  "versandaufteilungZuvielVerteilt",
                  -_vm.auflageLeft
                )
              ) +
              "\n    "
          ),
        ])
      : _vm.hasEmptyAddresses
      ? _c("div", { staticClass: "text-error font-weight-light" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("translate")("versandaufteilungLeereAdressen")) +
              "\n    "
          ),
        ])
      : _c("div", { staticClass: "text-success font-weight-light" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("translate")("versandaufteilungAlleVerteilt")) +
              "\n    "
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }